// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"e68b47ab","188":"d72652ae","317":"d733c592","453":"3e3490d8","456":"981eda90","708":"d4b9d5d0","719":"ce1bcdc8","946":"54d05fa7"}[chunkId] + ".chunk.js";
};